import Api from './api/api.constants';
import ColumnName from './column-name/column-name.constants';
import Grid from './grid/grid.constants';
import Kendo from '../../constants/kendo.constants';
import BillingReport from './billing-report/billing-report.constants';
import OilFileUpload from './file-upload/file-upload-oil.constants';
import CoolantFileUpload from './file-upload/file-upload-coolant.constants';
import SampleReport from './sample-report/sample-report.constants';
import Form from './form/form.constants';
import Dashboard from './dashboard/dashboard.constants';
import EventBus from './event-bus/event-bus.constants';
import Graph from './graph/graph.constants';
import UnitOfMeasures from './unitofmeasure.constants';
import Severities from './severity.constants';
import Water from './water.constants';

export default {
  Api,
  ColumnName,
  Grid,
  Kendo,
  BillingReport,
  OilFileUpload,
  CoolantFileUpload,
  SampleReport,
  Form,
  Dashboard,
  EventBus,
  Graph,
  UnitOfMeasures,
  Severities,
  Water
};
